<template>
  <div>
    <card-list
      title="Komponen Gaji"
      dataUrl="/api/v1/salary-item"
      dataSize="10"
      :dataHeaders="tHeaders"
      editRoute="/master/salary-item/add"
      deleteEndpoint="/api/v1/salary-item"
    />
  </div>
</template>
<script>
import CardList from "../../components/CardList";
export default {
  components: {
    CardList,
  },
  data () {
    return {
      tHeaders: [
        { id: 'ID', align: 'center' },
        { name: 'Name', align: 'left' },
        { slug: 'Slug', align: 'left' },
        { deleted_at: 'Status', align: 'center' },
        { item_type: 'Tipe', align: 'center' }
      ]
    }
  }
}
</script>
